import { render, staticRenderFns } from "./ExtsourceEdit.vue?vue&type=template&id=5a0933f4&"
import script from "./ExtsourceEdit.vue?vue&type=script&lang=js&"
export * from "./ExtsourceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports